import type { ContactFilter } from '@deltasuite/zoho-client';
import { dialApiFetch, isDialApiConfigured } from './client';

export interface SavedFilter {
  id: string;
  name: string;
  filter: ContactFilter;
  remember_last: boolean;
  last_used_at: string | null;
  created_at: string;
  updated_at: string;
}

export async function listSavedFilters(): Promise<SavedFilter[]> {
  if (!isDialApiConfigured) return [];
  const { rows } = await dialApiFetch<{ rows: SavedFilter[] }>('/v1/saved-filters');
  return rows;
}

export async function createSavedFilter(input: {
  name: string;
  filter: ContactFilter;
  remember_last?: boolean;
}): Promise<SavedFilter> {
  return dialApiFetch<SavedFilter>('/v1/saved-filters', {
    method: 'POST',
    body: input,
  });
}

export async function updateSavedFilter(
  id: string,
  patch: Partial<{
    name: string;
    filter: ContactFilter;
    remember_last: boolean;
    touch_last_used: boolean;
  }>,
): Promise<SavedFilter> {
  return dialApiFetch<SavedFilter>(`/v1/saved-filters/${id}`, {
    method: 'PATCH',
    body: patch,
  });
}

export async function deleteSavedFilter(id: string): Promise<void> {
  await dialApiFetch<{ ok: true }>(`/v1/saved-filters/${id}`, { method: 'DELETE' });
}
